import serviceUtil from "../..";

const PackageGetAll = () => {
  return serviceUtil
    .get("user/package/getAllPackageDetailsToBook")
    .then((res) => {
      const data = res && res.data;
      return { data };
    })
    .catch((err) => {
      const errRes = err && err.response.data;
      return { errRes };
    });
};

const getHolidayPackages = (type) => {
  const url = type ? `user/package/holiday-packages?type=${type}` : "user/package/holiday-packages";
  return serviceUtil
    .get(url)
    .then((res) => {
      const data = res && res.data;
      return { data };
    })
    .catch((err) => {
      const errRes = err && err.response.data;
      return { errRes };
    });
};

const getPackageDetail = (data) => {
  return serviceUtil
    .post("user/package/getPackageDetail", data)
    .then((res) => {
      const data = res && res.data;
      return { data };
    })
    .catch((err) => {
      const errRes = err && err.response.data;
      return { errRes };
    });
};

const Packagefilter = (data) => {
  return serviceUtil
    .post("user/filterSearch/packageFilter", data)
    .then((res) => {
      const data = res && res.data;
      return { data };
    })
    .catch((err) => {
      const errRes = err && err.response.data;
      return { errRes };
    });
};
const CreatePackageBookingGuestDetails = (data) => {
  return serviceUtil
    .post("user/package/createPackageBookingGuestDetails", data)
    .then((res) => {
      const data = res && res.data;
      return { data };
    })
    .catch((err) => {
      const errRes = err && err.response.data;
      return { errRes };
    });
};

const packageBookingEmail = (payload) => {
  return serviceUtil
    .post("user/package/packageBookingEmail", payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      const errRes = err;
      return { errRes };
    });
};

const packageTerms = (payload) => {
  return serviceUtil
    .post("user/package/packageTerms", payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      const errRes = err;
      return { errRes };
    });
};

const getSimilarPackages = (destination, currentPackageName, currentPackageId) => {
  const url = `user/package/similar-packages?destination=${encodeURIComponent(destination || "")}&currentPackageName=${encodeURIComponent(currentPackageName || "")}&currentPackageId=${encodeURIComponent(currentPackageId || "")}`;
  return serviceUtil
    .get(url)
    .then((res) => {
      const data = res && res.data;
      return { data };
    })
    .catch((err) => {
      const errRes = err && err.response?.data;
      return { errRes };
    });
};

const getPopularDestinations = (type) => {
  const url = type ? `user/package/popular-destinations?type=${type}` : "user/package/popular-destinations";
  return serviceUtil
    .get(url)
    .then((res) => {
      const data = res && res.data;
      return { data };
    })
    .catch((err) => {
      const errRes = err && err.response?.data;
      return { errRes };
    });
};

const getHolidayFaqs = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const url = query ? `user/package/holiday-faqs?${query}` : "user/package/holiday-faqs";
  return serviceUtil
    .get(url)
    .then((res) => {
      const data = res && res.data;
      return { data };
    })
    .catch((err) => {
      const errRes = err && err.response?.data;
      return { errRes };
    });
};

const getHolidayReviews = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const url = query ? `user/package/holiday-reviews?${query}` : "user/package/holiday-reviews";
  return serviceUtil
    .get(url)
    .then((res) => {
      const data = res && res.data;
      return { data };
    })
    .catch((err) => {
      const errRes = err && err.response?.data;
      return { errRes };
    });
};

export {
  PackageGetAll,
  getPackageDetail,
  Packagefilter,
  CreatePackageBookingGuestDetails,
  packageBookingEmail,
  packageTerms,
  getHolidayPackages,
  getSimilarPackages,
  getPopularDestinations,
  getHolidayFaqs,
  getHolidayReviews,
};
